module.exports = __webpack_public_path__ + "media/images/icons/ban-6263ba539dc926b3a417e3803b9d7f7c.svg";